
<div class="ui modal" id="Print_Modal_Voucher" style="width:274px; font-family:'Arial Narrow'">

    <table style="width:100%;border:0;margin-top: 50px;padding-right: 18px;" class="Print_Table_Class_Credit_voucher">

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="4" style="font-size:22px;font-weight:bold;text-align:center; padding-bottom: 2px;font-family:'Arial Narrow'">
                <span>{{"Credit_Voucher" | t}}</span>
            </td>
        </tr>

        <tr>
            <td colspan="4" style="padding:4px;font-size: 22px;font-weight:bold;text-align:center;padding-bottom: 2px;font-family:'Arial Narrow'">
                <!--<span>{{"Terminal_:" | t}} </span>--><span>{{this.tournamentsService.Credit_Voucher_Terminal}}</span>
            </td>
        </tr>


        <tr>
            <td colspan="4" style="padding:4px;font-size: 22px;font-weight:bold;text-align:center;padding-bottom: 2px;font-family:'Arial Narrow'">
                <!--<span>{{"Affiliates_:" | t}} </span>--><span>{{this.tournamentsService.Credit_Voucher_Affiliate }}</span>
            </td>
        </tr>

        <tr>
            <td colspan="4" style="padding:4px;font-size: 12px;font-weight:bold;text-align:center;padding-bottom: 2px;padding-top:12px;font-family:'Arial Narrow'">
                <span>{{"Created_:" | t}} </span><span>{{this.tournamentsService.Credit_Voucher_CreatedDate}}</span>
            </td>
        </tr>

        <tr>
            <td colspan="4" style="padding:4px;font-size: 12px;font-weight:bold;text-align:center;padding-bottom: 2px;padding-top:12px;font-family:'Arial Narrow'">
                <span>{{"Ticket_Nr_:" | t}} </span><span>{{this.tournamentsService.Credit_Voucher_TicketNr}}</span><span>({{this.tournamentsService.Credit_Voucher_TicketPassword}})</span>
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="2" style="font-size:12px;font-weight:bold;width:48%;font-family:'Arial Narrow';padding-bottom:20px;padding-top:20px">
                <span>{{"Amount_:" | t}}  </span>
            </td>
            <td colspan="2" style="padding-right:14px;text-align:right;font-size:12px;font-weight:bold;font-weight:bold;padding-bottom: 2px;width:51%;font-family:'Arial Narrow';padding-bottom:20px;padding-top:20px">
                {{this.tournamentsService.Credit_Voucher_Amount}}
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="4" style="font-size:15px;font-family:'Arial Narrow';padding-bottom:20px;padding-top:20px;text-align:center">
                <span>{{"Book_your_Credit_directly_while_scanning_your_Voucher_Ticket_or_the_balance_can_be_cashed_out_via_the_cashier." | t}}  </span>
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>


        <tr>
            <td colspan="4" style="font-size:15px;font-family:'Arial Narrow';text-align:center;padding-top:20px">
                <span>{{"Caution_:" | t}} </span>
            </td>
        </tr>
        <tr>
            <td colspan="4" style="font-size:15px;font-family:'Arial Narrow';text-align:center;padding-bottom:20px">
                <span>{{"If_you_lose_this_receipt_your_credits_can_not_be_paid_out!" | t}} </span>
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="4" style="padding-top:8px;margin-bottom:20px;font-family:'Arial Narrow'">
                <div style="width:180px;height:64px;margin:auto">
                    <svg id="Credit_Voucher_Barcode" style="width: 180px;margin: auto;display: block;"></svg>
                </div>
            </td>
        </tr>

    </table>



</div>
<div class="ui modal" id="Print_Last_Payout_Modal" style="width:274px; font-family:'Arial Narrow'">

    <table style="width:100%;border:0;margin-top: 50px;padding-right: 18px;" class="Print_Table_Class_Credit_voucher">

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="4" style="font-size:22px;font-weight:bold;text-align:center; padding-bottom: 2px;font-family:'Arial Narrow'">
                <span>{{"Credit_Voucher" | t}}</span>
            </td>
        </tr>

        <tr>
            <td colspan="4" style="padding:4px;font-size: 22px;font-weight:bold;text-align:center;padding-bottom: 2px;font-family:'Arial Narrow'">
                <!--<span>{{"Terminal_:" | t}} </span>--><span>{{this.tournamentsService.LSBranchId}}</span>
            </td>
        </tr>


        <tr>
            <td colspan="4" style="padding:4px;font-size: 22px;font-weight:bold;text-align:center;padding-bottom: 2px;font-family:'Arial Narrow'">
                <!--<span>{{"Affiliates_:" | t}} </span>--><span>{{this.tournamentsService.LSParentBranchId }}</span>
            </td>
        </tr>

        <tr>
            <td colspan="4" style="padding:4px;font-size: 12px;font-weight:bold;text-align:center;padding-bottom: 2px;padding-top:12px;font-family:'Arial Narrow'">
                <span>{{"Created_:" | t}} </span><span>{{this.tournamentsService.LSTicketDate}}</span>
            </td>
        </tr>

        <tr>
            <td colspan="4" style="padding:4px;font-size: 12px;font-weight:bold;text-align:center;padding-bottom: 2px;padding-top:12px;font-family:'Arial Narrow'">
                <span>{{"Ticket_Nr_:" | t}} </span><span>{{this.tournamentsService.LSTicketNo}}</span><span>({{this.tournamentsService.LSTicketPassword}})</span>
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="2" style="font-size:12px;font-weight:bold;width:48%;font-family:'Arial Narrow';padding-bottom:20px;padding-top:20px">
                <span>{{"Amount_:" | t}}  </span>
            </td>
            <td colspan="2" style="padding-right:14px;text-align:right;font-size:12px;font-weight:bold;font-weight:bold;padding-bottom: 2px;width:51%;font-family:'Arial Narrow';padding-bottom:20px;padding-top:20px">
                {{this.tournamentsService.LSAmount}}
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="4" style="font-size:15px;font-family:'Arial Narrow';padding-bottom:20px;padding-top:20px;text-align:center">
                <span>{{"Book_your_Credit_directly_while_scanning_your_Voucher_Ticket_or_the_balance_can_be_cashed_out_via_the_cashier." | t}}  </span>
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>


        <tr>
            <td colspan="4" style="font-size:15px;font-family:'Arial Narrow';text-align:center;padding-top:20px">
                <span>{{"Caution_:" | t}} </span>
            </td>
        </tr>
        <tr>
            <td colspan="4" style="font-size:15px;font-family:'Arial Narrow';text-align:center;padding-bottom:20px">
                <span>{{"If_you_lose_this_receipt_your_credits_can_not_be_paid_out!" | t}} </span>
            </td>
        </tr>

        <tr><td colspan="4" style="border-bottom:1px solid #313131"></td></tr>

        <tr>
            <td colspan="4" style="padding-top:8px;margin-bottom:20px;font-family:'Arial Narrow'">
                <div style="width:180px;height:64px;margin:auto">
                    <svg id="Last_Payout_Detail_Barcode" style="width: 180px;margin: auto;display: block;"></svg>
                </div>
            </td>
        </tr>

    </table>



</div>
